import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { LoginComponent } from '../../shared/components/login/login-component/login-component';
import { TranslatePipe } from '@ngx-translate/core';
import { LinkRegistration } from '../../shared/components/links/link-registration/link-registration';
import { AuthService } from '../../core/services/auth/auth.service';
import { ActivatedRoute, Router } from '@angular/router';

import { ProgressSpinnerModule } from '../../features/progress-spinner/progress-spinner-module';

import { SocialLinks } from '../../shared/components/links/social-links/social-links';
import { SelectLanguage } from '../../shared/components/language/select-language/select-language';
import { AllStatus } from '../../core/services/status/all-status';
import { Subscription, take } from 'rxjs';
import { LanguageService } from '../../core/services/language/language.service';
import { ConfigurationService } from '../../core/services/configs/configuration';



@Component({
  selector: 'app-home',
  imports: [LoginComponent, TranslatePipe, LinkRegistration,ProgressSpinnerModule, SocialLinks, SelectLanguage], // Achievement
  templateUrl: './home.html',
  styleUrl: './home.scss'
})
export class Home implements OnInit, OnDestroy{
  

  allStatus$ = inject(AllStatus);

  auth = inject(AuthService);
  router = inject(Router);
  actRoute = inject(ActivatedRoute);
  langService = inject(LanguageService);

  configuration = inject(ConfigurationService);

  subScription: Subscription;
  
  
  ngOnInit(): void { 
    //this.langService.catchAppLanguage$();
    if(!sessionStorage.getItem("app_language")){
      sessionStorage.setItem("app_language", JSON.stringify(this.langService.appLanguage));
    }
    if(this.auth.isLoggedIn){
      this.router.navigate(['/step-one']);
      return;
    }
    let txtSpiner = (this.langService.appLanguage === 'uk')?"Вхід у систему...": (this.langService.appLanguage === 'ru') ? "Вход в систему...":"Logging in...";
    this.subScription = this.actRoute.queryParams.pipe(
      take(1)
    ).subscribe(data=>{
      if(data?.key && !this.allStatus$.isAutorization){

        this.allStatus$.textSpinner = txtSpiner;//
        this.allStatus$.setDisplayProgressSpinner(true);
        this.auth.TokenRefresh = data.key;
        this.auth.refreshAuthToken().pipe(
          take(1)
        ).subscribe({
          next:(res)=>{
            this.configuration.setConfig().subscribe({
              next: () => this.router.navigate(['/step-one']),
              error: (error) => {
                this.allStatus$.setDisplayProgressSpinner(false);
                console.error(error);
              }
            });
          },
          error:(error)=>{
            this.allStatus$.setDisplayProgressSpinner(false);
            console.error(error);
          }
        });
      }
    });
  }

  ngOnDestroy(): void {
    if(this.subScription){
      this.subScription.unsubscribe();
    }
  }

}
